export default __webpack_public_path__ + "static/media/section1_tool.09caf48c.png";